import { Instance, applySnapshot, flow, types } from 'mobx-state-tree';

import { getOnboardingGoals } from './apiWrappers/wrappers/useOnboarding';
import { Goal } from './types/useOnboarding.types';

const OnboardingGoalModel = types.model('OnboardingGoalModel', {
  description: types.string,
  title: types.string,
  id: types.number,
});

const OnboardingStoreModel = types
  .model('OnboardingStoreModel', {
    onboardingGoals: types.optional(types.array(OnboardingGoalModel), []),
  })
  .actions((self) => ({
    fetchAndSetOnboardingGoals: flow(function* fetchOnboardingGoals(planLabelsIds: string[], mainSegment: string) {
      const { data, kind } = yield getOnboardingGoals(planLabelsIds, mainSegment);

      if (kind === 'ok') {
        const rawGoals = data.goals as Goal[];
        const mappedGoals: OnboardingGoal[] = rawGoals.map((goal: Goal, index) => ({
          description: goal.description,
          title: goal.title,
          id: index + 1,
        }));
        applySnapshot(self, { ...self, onboardingGoals: mappedGoals });
      }
    }),
  }));

interface OnboardingGoal extends Instance<typeof OnboardingGoalModel> {}
interface Onboarding extends Instance<typeof OnboardingStoreModel> {}

export { Onboarding, OnboardingStoreModel };
